import { initialLyceeState, LyceeDef } from '../../types/lycee/lycee.def';
import { initErrorFields } from '../../helpers/forms/error/errorFieldHelper';
import {
  CREATE_LYCEE,
  SetLyceeFormAction
} from '../actions/createLyceeClasse.actions';
import { MainFormState } from '../../types/forms/form.def';

export type CreateLyceeState = MainFormState<LyceeDef>;

const initialState: CreateLyceeState = {
  errors: initErrorFields(initialLyceeState),
  values: initialLyceeState,
  isValid: false
};

const createLyceeReducer = (
  state: CreateLyceeState = initialState,
  action: SetLyceeFormAction
) => {
  switch (action.type) {
    case CREATE_LYCEE: {
      const newState: CreateLyceeState = {
        ...state,
        ...action.payload
      };
      return newState;
    }
    default:
      return state;
  }
};

export default createLyceeReducer;
